import React, { forwardRef, useImperativeHandle } from "react";
import { H1, P2, P3 } from "../theme/text/Headings";
import { LoadingContainer } from "./ProfileStyles";
import { useProfileInsights } from "../../hooks/profile/useProfileInsights";
import { OffWhite } from "../theme/colors";

const ProfileOverviewInsights = ({ userId, displayName }, ref) => {
  const {
    state: { profileOverview, allQuizData, loading, error, isRegenerating },
    actions: { regenerateInsights },
  } = useProfileInsights({ userId, displayName });

  useImperativeHandle(ref, () => ({
    regenerateInsights,
  }));

  if (!allQuizData || allQuizData.length === 0) {
    return null;
  }

  if (loading || isRegenerating) {
    const loadingText = isRegenerating
      ? "Regenerating your personality insights..."
      : "AI is analyzing your personality profiles...";

    return (
      <LoadingContainer>
        <H1>{loadingText}</H1>
        <P3
          className="mt-10 text-align-left"
          style={{ alignSelf: "flex-start" }}
        >
          Generating insights from {allQuizData.length} completed quiz
          {allQuizData.length > 1 ? "es" : ""}
        </P3>
      </LoadingContainer>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <H1>Unable to generate insights</H1>
        <P3 style={{ marginTop: "10px" }}>Error: {error}</P3>
        <P3 style={{ marginTop: "10px", fontSize: "12px" }}>
          Check the browser console for more details
        </P3>
      </div>
    );
  }

  if (!profileOverview) {
    return (
      <LoadingContainer>
        <H1>Preparing your personality insights...</H1>
      </LoadingContainer>
    );
  }

  return <P2 color={OffWhite}>{profileOverview}</P2>;
};

export default forwardRef(ProfileOverviewInsights);
